export default __webpack_public_path__ + "static/media/arrow.981b80ec.svg";